<p-dialog
  [header]="settings.showCustomHeader ? 'Header' : dialogHeader"
  [(visible)]="isVisible"
  [modal]="settings.modal ?? true"
  [position]="settings.position || 'center'"
  [maximizable]="settings.isMaximizable"
  [breakpoints]="settings.breakpoints"
  [draggable]="settings.isDraggable"
  [resizable]="settings.isResizable"
  [closeOnEscape]="settings.closeOnEscape"
  [focusOnShow]="false"
  [style]="{ width: settings.width, maxWidth: settings.maxWidth }"
  [styleClass]="'assign-sub-driver-dialog'"
  [class]="customClass"
  (onShow)="handleOnShow()"
  (onHide)="handleOnHide()"
  (onDragEnd)="handleOnDragEnd()"
  (onMaximize)="handleOnMaximize()"
>
  <!-- Custom close icon -->
  @if (settings.useCustomCloseIcon) {
    <ng-template pTemplate="closeicon">
      <ng-content select="[dialog-close-icon]"></ng-content>
    </ng-template>
  }
  <!-- Custom maximize icon -->
  @if (settings.useCustomMaximizeIcon) {
    <ng-template pTemplate="maximizeicon">
      <ng-content select="[dialog-maximize-icon]"></ng-content>
    </ng-template>
  }
  <!-- Custom minimize icon -->
  @if (settings.useCustomMinimizeIcon) {
    <ng-template pTemplate="minimizeicon">
      <ng-content select="[dialog-minimize-icon]"></ng-content>
    </ng-template>
  }

  <!-- Custom header -->
  @if (settings.showCustomHeader) {
    <ng-template pTemplate="header">
      <ng-content select="[dialog-header]"></ng-content>
    </ng-template>
  }

  <!-- Custom content -->
  @if (settings.showCustomContent) {
    <ng-template pTemplate="content">
      <ng-content select="[dialog-content]"></ng-content>
    </ng-template>
  } @else {
    <ng-content></ng-content>
  }

  <!-- Custom footer -->
  @if (settings.showCustomFooter) {
    <ng-template pTemplate="footer">
      <ng-content select="[dialog-footer]"></ng-content>
    </ng-template>
  }
</p-dialog>
